module.exports = __webpack_public_path__ + "img/horizontal_7_6_7042.34caf556.png";